import { Field, ObjectType } from "type-graphql";
import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn } from "typeorm";

/** The user theme enum */
export enum UserTheme {
    Dark = "dark",
    Light = "light"
}

/** The user locale enum */
export enum UserLocale {
    EN_GB = "en_GB",
    NL_NL = "nl_NL"
}

/** Represents a user for authorization and profile */
@Entity({
    name: 'user'
})
@ObjectType()
export default class User {
    /** The planning uuid */
    @PrimaryGeneratedColumn('uuid')
    @Field(() => String)
    public uuid: string

    /** Full name of the user */
    @Column('varchar')
    @Field(() => String)
    public fullName: string

    /** Email address of the user */
    @Column('varchar')
    @Field(() => String)
    public email: string

    /** Salt key to encrypt the password with */
    @Column('varchar')
    public salt: string

    /** Whether or not the user has been activated */
    @Column('boolean')
    @Field(() => String)
    public activated: boolean

    /** The activation key of the user */
    @Column('varchar')
    public activationKey: string

    /** The password */
    @Column('varchar')
    public password: string
    
    /** The locale */
    @Column('enum', {
        enum: UserLocale
    })
    @Field(() => String)
    public locale: UserLocale

    /** The selected theme */
    @Column('enum', {
        enum: UserTheme
    })
    @Field(() => String)
    public theme: UserTheme = UserTheme.Light

    /** Whether the user agreed to the terms, must be true */
    @Column('boolean')
    public agreedToTerms: boolean = false

    /** Whether the user is an admin */
    @Column('boolean')
    @Field(() => Boolean)
    public isAdmin: boolean = false

    /** The created at timestamp */
    @CreateDateColumn({
        type: 'timestamp'
    })
    @Field(() => Date)
    public createdAt: Date

    /** The timestamp at which it was updated */
    @UpdateDateColumn({
        type: 'timestamp',
        name: 'updatedAt'
    })
    @Field(() => Date)
    public updatedAt: Date
}